export default {
      id: "ar_etat_civil-usage",
      viewBox: "0 0 65 50",
      url: "../dist/images/" + "sprite.svg#ar_etat_civil-usage",
      toString: function () {
        return this.url;
      }
    }